import React from 'react';
import liveUser from '../../../assets/img/live-imgs/live-user1.png'
import eyeIcon from '../../../assets/img/live-imgs/eye.svg'
const LivePageSingleElement = () => {
    const userLiveDatas = [
        {
            liveWatchPeopleSum : "2.1k",
            nameOfLivePeople: "Natasha Robert",
            shortDesc: "Lorem ipsum dolor sit amet."
        },
        {
            liveWatchPeopleSum : "3.1k",
            nameOfLivePeople: "Maruf Robert",
            shortDesc: "Lorem ipsum dolor sit amet."
        },
        {
            liveWatchPeopleSum : "2.5k",
            nameOfLivePeople: "Mobin Robert",
            shortDesc: "Lorem ipsum dolor sit amet."
        },
        {
            liveWatchPeopleSum : "2.1k",
            nameOfLivePeople: "Haider Robert",
            shortDesc: "Lorem ipsum dolor sit amet."
        },
        {
            liveWatchPeopleSum : "2.1k",
            nameOfLivePeople: "Manoj Robert",
            shortDesc: "Lorem ipsum dolor sit amet."
        },
        {
            liveWatchPeopleSum : "2.1k",
            nameOfLivePeople: "Laila",
            shortDesc: "Lorem ipsum dolor sit amet."
        },
    ]
    return (
        <div className='row gy-4'>
            {
                userLiveDatas.map(( item, index) =>  <div className="col-12 col-md-6 col-xxl-4" key={index}>
                        <div className="mb-1 position-relative">
                            <img className="w-100" src={liveUser} alt='' />
                            <div className="position-absolute px-1 rounded-pill d-flex justify-content-center align-items-center gap-1 l_wbadge">
                                <img src={eyeIcon} alt='' />
                                    <span className="l_watch">{item.liveWatchPeopleSum}</span>
                            </div>
                            <div className="position-absolute px-2 rounded-pill d-flex justify-content-center align-items-center l_badge">
                                <span className="b-live">LIVE</span>
                            </div>
                        </div>
                        <div className="d-grid">
                            <span className="center_txt">{item.nameOfLivePeople}</span>
                            <span className="l-txt">Lorem ipsum dolor sit amet.</span>
                        </div>
                    </div> 
                ) 
            }
        </div>
    );
};

export default LivePageSingleElement;